import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import theme from 'theme'

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border: 1px solid ${theme.colors.dropdownBorder};
    border-radius: ${theme.attributes.borderRadius.tertiary};
  }

  label {
    color: ${theme.colors.devicesSecondaryText};

    &[data-shrink='true'] {
      color: ${theme.colors.dropdownLabel};
      background-color: ${theme.colors.labelCardBg};
    }
  }

  input,
  textarea {
    color: ${theme.colors.menuItemText};
  }

  &.Mui-disabled {
    opacity: 1;

    input,
    textarea {
      -webkit-text-fill-color: ${theme.colors.menuItemText};
      text-transform: capitalize;
    }
  }

  fieldset {
    border: none;
  }

  .Mui-focused fieldset {
    border: 1px solid ${theme.colors.cta} !important;
    border-radius: ${theme.attributes.borderRadius.tertiary};
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    color: ${theme.colors.errorLight} !important;
  }
`

export const CharacterCountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  font-size: ${theme.typography.fontSize.medium};
  color: ${theme.colors.dropdownLabel};
`
